import config from './../config';

const baseUrl = config.get('AUTHENTICATION_API_URL');
const users = `${baseUrl}/users`;
const userClients = `${baseUrl}/user-clients`;
const changePassword = `${baseUrl}/change-password`;
const invitations = `${baseUrl}/invitations`;
const createInvitations = `${invitations}/batch`;
const bulkApproveInvitations = `${invitations}/approve`;
const bulkReinviteUsers = `${invitations}/reinvite`;

const AuthApiRoutes = {
  BASE: baseUrl,
  USERS: users,
  USER_CLIENTS: userClients,
  CHANGE_PASSWORD: changePassword,
  CREATE_SALESFORCE_USER: '/salesforce-integration',
  INVITATIONS: invitations,
  CREATE_INVITATIONS: createInvitations,
  BULK_APPROVE_INVITATIONS: bulkApproveInvitations,
  BULK_REINVITE_USERS: bulkReinviteUsers
};

export default AuthApiRoutes;